module.exports = __webpack_public_path__ + "img/AI (3).88a56d22.png";